var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.97 7.19V13.37H2V7.19C2 4.88 3.88 3 6.19 3H16.78C19.09 3 20.97 4.88 20.97 7.19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.3701V13.5601C2 15.8801 3.88 17.7501 6.19 17.7501H9.79C10.34 17.7501 10.79 18.2001 10.79 18.7501V19.5701C10.79 20.1201 10.34 20.5701 9.79 20.5701H7.53C7.14 20.5701 6.82 20.8901 6.82 21.2801C6.82 21.6701 7.14 21.9901 7.53 21.9901H15.46C15.85 21.9901 16.17 21.6701 16.17 21.2801C16.17 20.8901 15.85 20.5701 15.46 20.5701H13.21C12.66 20.5701 12.21 20.1201 12.21 19.5701V18.7501C12.21 18.2001 12.66 17.7501 13.21 17.7501H16.78C19.1 17.7501 20.97 15.8701 20.97 13.5601V13.3701H2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.99 2.35962L20.86 3.14962V2.72962C20.86 1.77962 20.09 1.01962 19.15 1.01962H14.87C13.84 1.00962 13 1.84962 13 2.87962V6.15962C13 7.01962 13.43 7.86962 14.71 7.86962H19.14C20.09 7.86962 20.85 7.09962 20.85 6.15962V5.72962L21.98 6.51962C22.55 6.90962 23 6.66962 23 5.98962V2.88962C23 2.20962 22.55 1.97962 21.99 2.35962Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.a97ba243a69604936f5d3169fa865383.svg";
export { ForwardRef as ReactComponent };